import { QueryClient } from '@tanstack/react-query'
import { onAuthReset } from '@/store/authStore'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})

// Aislamiento multitenant: purgar caché en memoria al cerrar sesión o cambiar de tenant
onAuthReset(() => {
  queryClient.clear()
})
